<template>
	<div class="progress" id="progress" :style="'margin-top:'+playHeight+'px'">
		<div class="progressbg"></div>
		<div class="progressfg" :style="'background-image:url('+imgPath+'home/loadingbg.png)'"></div>
		<div class="progressimgbg">
			<img class="progressimg" :src="imgPath+'home/loadingImg.png'"></img>
		</div>
		<p class="progressText">
			loading<span class="progressTextdot">.....</span>
		</p>
	</div>
</template>

<script>
import Vue from 'vue';
import tool from '../../kits/Tools.js';

export default {
	data() {
		return {
			imgPath:'',
		}
	},
	props:['playHeight'],
	mounted() {
		this.imgPath = tool.imgPath();
	},
	methods: {
	}
}
</script>

<style>
	.progress {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		background-color: #4A4A4A;
		height: 56vw;
		z-index: 99;
	}
	
	.progress .progressbg {
		position: absolute;
		width: 200px;
		top: 50%;
		left: 50%;
		margin-left: -100px;
		height: 10px;
		margin-top: -10px;
		border-radius: 5px;
		background-color: #EEEEEE;
	}
	
	.progress .progressfg {
		animation: progressfgAnim 5s;
		animation-iteration-count: infinite;
		position: absolute;
		width: 200px;
		top: 50%;
		left: 50%;
		margin-left: -100px;
		height: 10px;
		margin-top: -10px;
		border-radius: 5px;
	}
	
	.progress .progressimgbg {
		position: absolute;
		width: 100px;
		top: 50%;
		left: 50%;
		margin-left: -100px;
		height: 10px;
		margin-top: -10px;
	}
	
	.progress .progressimgbg .progressimg {
		animation: progressimgAnim 5s;
		animation-iteration-count: infinite;
		position: absolute;
		width: 31px;
		top: 50%;
		left: 100%;
		margin-left: -15px;
		height: 33px;
		margin-top: -19px;
	}
	
	.progress .progressText {
		position: absolute;
		width: 100%;
		top: 50%;
		height: 20px;
		text-align: center;
		margin-top: 30px;
		color: white;
		font-size: 18px;
	}
	
	.progress .progressText .progressTextdot {
		white-space: nowrap;
		overflow: hidden;
		animation: progressTextdotAnim 3s;
		animation-iteration-count: infinite;
		display: inline-block;
	}
	
	@keyframes progressfgAnim {
		from {
			width: 0px;
		}
		to {
			width: 200px;
		}
	}
	
	@keyframes progressimgAnim {
		from {
			left: 0px;
		}
		to {
			left: 200px;
		}
	}
	
	@keyframes progressTextdotAnim {
		0% {
			width: 0px;
		}
		20% {
			width: 5px;
		}
		40% {
			width: 9px;
		}
		60% {
			width: 10px;
		}
		80% {
			width: 15px;
		}
		100% {
			width: 20px;
		}
	}
</style>


// WEBPACK FOOTER //
// proGress.vue?4cbe028c